<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  name: 'App',
  data() {
    return {
      zhCN
    }
  },
  methods: {
    userLoaded: function(e) {
      console.log('I am listening to the user loaded event', e.detail)
    }
  },
  mounted() {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
  },
  unmounted() {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
  }
}
</script>
